const BE = {
  company: [
    "besloten vennootschap (BV) / société à responsabilité limitée (SRL)",
    "vereniging zonder winstoogmerk (VZW) / association sans but lucratif (ASBL)"
  ],
  legalArrangement: [
    "commanditaire vennootschap op aandelen (Comm.VA) / société en commandite par actions (SCA)"
  ],
  soleProprietorship: [
    "eenmanszaak / entreprise individuelle"
  ]
};
export {
  BE as default
};
